export default "__VITE_ASSET__CeTNzM4X__"